import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-cream"><Loader2 className="animate-spin text-wine" /></div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
